// Replace em dashes (\u2014) and en dashes (\u2013) with a comma. The backend
// already sanitizes generated and edited posts; this mirrors it on the client
// for anything typed directly into the editor.
export const stripDashes = (s) =>
  s ? String(s).replace(/\s*[\u2014\u2013]\s*/g, ", ") : s;

// Remove emojis and pictographs. Mirrors the backend sanitizer so the editor
// preview matches what gets saved.
const EMOJI =
  /[\u{1F300}-\u{1FAFF}\u{1F000}-\u{1F0FF}\u{1F1E6}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2B00}-\u{2BFF}\u{2300}-\u{23FF}\u{FE00}-\u{FE0F}\u{200D}]/gu;

export const stripEmoji = (s) =>
  s ? String(s).replace(EMOJI, "").replace(/[ \t]{2,}/g, " ").trim() : s;

export const clean = (s) => stripEmoji(stripDashes(s));

export function formatPost(post) {
  let t = post.body || "";
  if (post.hashtags && post.hashtags.length) {
    t += "\n\n" + post.hashtags.map((h) => "#" + h).join(" ");
  }
  if (post.cta) t += "\n\n" + post.cta;
  return clean(t).trim();
}
